import { ref, toValue, onMounted, watch } from 'vue';

import { useRefEventListener } from 'JIX/eventListener.js';

export function useNavigationHistory({ url, state, onPop, onPush }) {
    let poppingHistory = false;

    const serializeState = () => JSON.parse(JSON.stringify(toValue(state))); // the history API cannot clone proxy values

    onMounted(() => {
        watch(
            url,
            (newUrl) => {
                if (poppingHistory) { // if the URL is updating because we are popping the state, we shouldn't push a new entry
                    poppingHistory = false;
                } else {
                    const serializedState = serializeState();
                    history.pushState(serializedState, '', newUrl);
                    onPush?.({ url: newUrl, state: serializedState });
                }
            },
        );

        history.replaceState(serializeState(), '', toValue(url)); // save initial state

        useRefEventListener(ref(window), 'popstate', (event) => {
            poppingHistory = true;
            onPop?.({ url: location.href, state: event.state });
        });
    });
}
